import { faMagnifyingGlass, faArrowLeft, faBellConcierge, faUserTie, faHandPaper, faCheckCircle, faExclamationTriangle, faBell } from "@fortawesome/free-solid-svg-icons";
import { faUser, faHeart } from "@fortawesome/free-regular-svg-icons";

const icons = {
    search: faMagnifyingGlass,
    back: faArrowLeft,
    user: faUser,
    favorite: faHeart,
    bellConcierge: faBellConcierge,
    userTie: faUserTie,
    handPaper: faHandPaper,
    checkCircle: faCheckCircle,
    exclamationTriangle: faExclamationTriangle,
    bell: faBell,
  };
  
  export default icons;